<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form ref="form" :model="form" label-width="85px">
                <el-row :gutter="10">
                  <el-col>
                    <el-form-item label="输入搜索：">
                      <el-col :span="3">
                        <el-select
                          v-model="form.sys_type"
                          placeholder="系统类型"
                        >
                          <el-option label="全部" value=""></el-option>
                          <el-option label="后台ERP" value="1"></el-option>
                          <el-option label="仓储APP" value="2"></el-option>
                          <el-option label="代采APP" value="3"></el-option>
                          <el-option label="YS-APP" value="4"></el-option>
                          <el-option label="朱雀手持" value="5"></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="2">
                        <el-input
                          v-model="form.admin"
                          placeholder="更新人"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="更新时间：">
                          <el-date-picker
                            v-model="form.create_time"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="2">
                        <el-button type="primary" @click="search">
                          查询</el-button
                        >
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <el-button
            style="margin-left: auto"
            type="warning"
            size="mini"
            @click="AddVersion(0)"
            >创建更新
          </el-button>
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              prop="version_sys_type"
              label="类型"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="is_force_update"
              label="是否强制更新"
              align="center"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.is_force_update == 1">是</div>
                <div v-if="scope.row.is_force_update == 0">否</div>
              </template>
            </el-table-column>
            <el-table-column prop="version" label="版本" align="center">
            </el-table-column>
            <el-table-column prop="update_url" label="更新地址" align="center">
            </el-table-column>
            <el-table-column
              prop="update_desc"
              label="更新说明"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="status_txt"
              label="状态"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="admin_name"
              label="更新人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="更新时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column prop="" label="操作" align="center" width="100">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.can_edit == 1"
                  size="small"
                  type="text"
                  @click="AddVersion(scope.row.id)"
                  >编辑</el-button
                >
                <el-button
                  v-if="scope.row.can_edit == 0"
                  disabled
                  size="small"
                  type="text"
                  >编辑</el-button
                >
                <el-button
                  v-if="scope.row.can_rollback == 1"
                  size="small"
                  type="text"
                  @click="rollback(scope.row.id)"
                  >回滚</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.count"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div v-if="showbox">
      <version-info :id="id" @onCloseDialog="closeBox"></version-info>
    </div>
  </div>
</template>

<script>
import VersionInfo from "./components/VersionInfo.vue";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  components: {
    VersionInfo,
  },
  data() {
    return {
      id: 0,
      showbox: false,
      images: [],
      resData: null,
      form: {
        status: "",
      },
      loading: false, // 加载动画是否显示
      url: "/erp/Setting/versionList",
      status: "",
      curPage: 1,
      loading: false,
      tableLoading: false,
      filterFold: false,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        console.log(key);
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    AddVersion(id) {
      this.id = Number(id);
      this.showbox = true;
    },
    closeBox() {
      this.showbox = false;
      this.showlog = false;
      this.fetchData();
    },
    handleClick(pg_id) {
      this.$router.push(`/home/supply/supplyList?pg_id=${pg_id}`);
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          console.log(res);
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    fetchData(showLoading) {
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onSubmit() {
      console.log("submit!");
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.form.page = val;
      this.loading = true;
      this.$http.post(this.url, this.form).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.fetchData();
    },
    rollback(id) {
      this.$confirm("确定回滚到上一个有效版本?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.loading = true;
        this.$http
          .post("/erp/Setting/rollBack", { id })
          .then((result) => {
            this.loading = false;
            if (result.data.code != 200) {
              return this.$message.error(result.data.msg);
            }
            this.fetchData();
            this.$message.success(result.data.msg);
          })
          .catch((err) => {});
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1 px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.demo-form-inline .el-form-item {
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/setting/Version.vue